import http from '@/utils/http'

export function getOrders(params){
    return  http('/orders',{params})
}
export function addOrders(data){
    return  http.post('/orders',data)
}
export function getOrderDetail(id){
    return  http(`/orders/${id}`)
}
export function payRequest(id){
    return  http.post(`/orders/${id}/pay_request`)
}
export function paySkip(id){
    return  http.post(`/orders/${id}/code_pay`)
}
export function getPromotionCodes(params){
    return  http('/promotion_codes',{params})
}